import { render, staticRenderFns } from "./GeoSelector.vue?vue&type=template&id=18396990&scoped=true&"
import script from "./GeoSelector.vue?vue&type=script&lang=js&"
export * from "./GeoSelector.vue?vue&type=script&lang=js&"
import style0 from "./GeoSelector.vue?vue&type=style&index=0&id=18396990&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18396990",
  null
  
)

export default component.exports